type PasswordVisibilityIconProps = {
  visible: boolean;
  size?: number;
  color?: string;
};

const STROKE_WIDTH = 1.2;

const EYE_OUTLINE_PATH =
  'M1.5 8C2.92 5.8 5.28 4.2 8 4.2C10.72 4.2 13.08 5.8 14.5 8C13.08 10.2 10.72 11.8 8 11.8C5.28 11.8 2.92 10.2 1.5 8Z';

const PasswordVisibilityIcon = ({
  visible,
  size = 16,
  color = '#5e5e60',
}: PasswordVisibilityIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <path
      d={EYE_OUTLINE_PATH}
      stroke={color}
      strokeWidth={STROKE_WIDTH}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="8" cy="8" r="2" stroke={color} strokeWidth={STROKE_WIDTH} />
    {visible ? (
      <path
        d="M2.75 2.75L13.25 13.25"
        stroke={color}
        strokeWidth={STROKE_WIDTH}
        strokeLinecap="round"
      />
    ) : null}
  </svg>
);

export default PasswordVisibilityIcon;
